// Model.js
// -----------------------
// @module Case
define("CV.TariffCalculation.TariffModule.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/TariffModule/SuiteScript2/TariffModule.Service.ss"
            ),
            true
        )
});
});
